import { create } from "@/store";

export type RenamedDevice = {
  role: StoreDevice["role"];
  jid: string;
  name: string;
};

export const useDeviceRename = create<{
  device: RenamedDevice | null;
  isOpen: boolean;
  open: ({ device }: { device: RenamedDevice }) => void;
  close: () => void;
}>()((set) => ({
  isOpen: false,
  device: null,
  open({ device }) {
    set({ isOpen: true, device });
  },
  close() {
    set({ isOpen: false });
  }
}));
